module.exports = "/_next/static/images/kaijin_top-aa6667965312a3da53886a405ab9c4bb.jpg";